// FixedElement
// Gives the element a fixed class depending on multiple vars

// When not defined there's no fixed element
if (typeof fixedHeader == 'undefined') {
    var headerHeight = 0;
} else {
    var headerHeight = $('.header-section.fixed').height();
}


$(window).on('load', function(){
    if ($('[data-fixed-element="child"]').length>0) {
        fixedSidebar();
        $(window).resize(fixedSidebar);
        $(window).scroll(fixedSidebar);
    }

    var fixedParent = $('[data-fixed-element="child"]');
    var sidebarHeight = Math.round($('[data-fixed-element="child"]').outerHeight());

    function fixedSidebar() {

        // Copy width
        $('[data-fixed-element="child"]').width($('[data-fixed-element="parent"]').width());

        fixedParent = $('[data-fixed-element="parent"]');
        scrollParent = $(fixedParent).siblings().outerHeight();
        sidebarHeight = Math.round($('[data-fixed-element="child"]').outerHeight());

        // Disable fixed element on small screens AND element is larger than parent
        if(g_windowWidth >= 960 && sidebarHeight <= scrollParent){

            // Check if element is higher than window height
            if (sidebarHeight > g_windowHeight) {
                var scroll			= Math.round(g_scroll+g_windowHeight);
                var offsetTop		= Math.round($(fixedParent).offset().top+sidebarHeight+headerHeight-30);
                var offsetBottom	= Math.round($(fixedParent).parent().outerHeight()+$(fixedParent).parent().offset().top)-headerHeight-20;

            } else {
                var scroll			= Math.round(g_scroll+headerHeight);
                var offsetTop		= Math.round($(fixedParent).offset().top-10);
                var offsetBottom	= Math.round(($(fixedParent).parent().outerHeight()+$(fixedParent).parent().offset().top)-sidebarHeight)-headerHeight-20;
            }

            // set fixed - set bottom - unset
            if (scroll >= offsetTop && scroll < offsetBottom) {
                $('[data-fixed-element="child"]').css("position", "fixed");
                if (sidebarHeight > g_windowHeight) {
                    $('[data-fixed-element="child"]').css("top", "auto").css("bottom", 0);
                } else {
                    $('[data-fixed-element="child"]').css("bottom", "auto").css("top", headerHeight + 20);
                }
            } else if (scroll >= offsetBottom) {
                $('[data-fixed-element="child"]').css("position", "absolute").css("top", "auto").css("bottom", "49px");
            } else {
                $('[data-fixed-element="child"]').css("position", "relative").css("top", "auto").css("bottom", "auto");
            }

        } else {
            $('[data-fixed-element="child"]').removeClass("fixed").removeClass("bottom");
        }

    }
});
